import Listener from './listener'

/** VBD mode listener.
 *  @extends {Listener}
 */
export default class VBDModeListener extends Listener
{

}
